import setCookie from './functions/_cookie-setCookie-server.js' // Cookie発行（サーバーサイド）
import getCookie from './functions/_cookie-getCookie.js' // Cookie取得

/* global rootDomain */

let cookiePath = '/cookie/' // cookie制御パス

// console.log({ rootDomain })

//  #####      ###    ######  #####
//  ##  ##    ## ##     ##    ##
//  #####    ##   ##    ##    #####
//  ##  ##   #######    ##    ##
//  ##   ##  ##   ##    ##    #####
// レーティングの確認を省略する

const rateBtn = document.getElementById('rateAgree')
const rateLink = rateBtn.href

// 承諾したらCookieを記録
window.addEventListener('click', function (e) {
  // 指定のIDを持つ
  if (e.target.id !== 'rateAgree') {
    return
  }

  goR18() // R18切り替え
})

function goR18() {
  // Cookieを設定
  setCookie('isR', 1, cookiePath, 60 * 60 * 24 * 365, true) // Cookie発行
  setCookie('isR', 1, cookiePath, 60 * 60 * 24 * 365, true, '/', 'lax', ';domain=.' + location.hostname) // Cookie発行
  if (location.hostname !== rootDomain) {
    setCookie('isR', 1, cookiePath, 60 * 60 * 24 * 365, true, '/', 'lax', ';domain=.' + rootDomain) // Cookie発行
  }
  setCookie('rateAgree', 1, cookiePath, 60 * 60 * 24 * 7, true) // Cookie発行
  setCookie('rateAgree', 1, cookiePath, 60 * 60 * 24 * 7, true, '/', 'lax', ';domain=.' + location.hostname) // Cookie発行
  if (location.hostname !== rootDomain) {
    setCookie('rateAgree', 1, cookiePath, 60 * 60 * 24 * 7, true, '/', 'lax', ';domain=.' + rootDomain) // Cookie発行
  }

  // パラメータ'page'をURLから削除
  const url = new URL(window.location.href)
  url.searchParams.delete('page')
  const cleanUrl = url.toString()

  // クッキーが切り替わるのを確認したらリロード
  const reloadTimer = setInterval(() => {
    if (!getCookie('isR')) {
      return
    }
    clearInterval(reloadTimer)
    // ジャンプ先があればジャンプ
    const jump = getCookie('jump')
    if (getCookie('jump')) {
      setCookie('jump', '', cookiePath, 0, true) // Cookie発行
      setCookie('jump', '', cookiePath, 0, true, '/', 'lax', ';domain=.' + location.hostname) // Cookie発行
      if (location.hostname !== rootDomain) {
        setCookie('jump', '', cookiePath, 0, true, '/', 'lax', ';domain=.' + rootDomain) // Cookie発行
      }
      // パラメータ'page'をjump URLから削除
      const jumpUrl = new URL(jump, window.location.origin)
      jumpUrl.searchParams.delete('page')
      location.href = jumpUrl.toString()
    } else {
      // ジャンプ先がなければリロード
      location.href = cleanUrl
    }
  }, 100)
}

// Cookieがあったらモーダルをカット
// const rateAgree = getCookie('rateAgree') // Cookie取得
// if (rateAgree === '1') {
//   // モーダルを消す
//   const rateModal = document.getElementsByClassName('js-modal--rating')
//   for (const iterator of rateModal) {
//     iterator.classList.add('js-modal--rating-del')
//   }
//   const rateModalDel = document.getElementsByClassName('js-modal--rating-del')
//   for (const iterator of rateModalDel) {
//     iterator.classList.remove('js-modal--rating') // モーダルを消す
//   }

//   window.addEventListener('click', function (e) {
//     // 指定のクラスを持つ
//     if (e.target.dataset.modal !== 'rating') {
//       return
//     }

//     // Cookieを設定
//     setCookie('isR', 1, cookiePath, 60 * 60 * 24 * 365, true) // Cookie発行
//     setCookie('isR', 1, cookiePath, 60 * 60 * 24 * 365, true, '/', 'lax', ';domain=.' + location.hostname) // Cookie発行
//     if (location.hostname !== rootDomain) {
//       setCookie('isR', 1, cookiePath, 60 * 60 * 24 * 365, true, '/', 'lax', ';domain=.' + rootDomain) // Cookie発行
//     }

//     // ジャンプ先があればジャンプ
//     const jump = getCookie('jump')
//     if (getCookie('jump')) {
//       setCookie('jump', '', cookiePath, 0, true) // Cookie発行
//       setCookie('jump', '', cookiePath, 0, true, '/', 'lax', ';domain=.' + location.hostname) // Cookie発行
//       if (location.hostname !== rootDomain) {
//         setCookie('jump', '', cookiePath, 0, true, '/', 'lax', ';domain=.' + rootDomain) // Cookie発行
//       }
//       location.href = jump
//     } else {
//       // ジャンプ先がなければリロード
//       window.location.reload()
//     }
//   })
// }

//  #####    #####  ######  ##   ##  #####    ##     ##
//  ##  ##   ##       ##    ##   ##  ##  ##   ####   ##
//  #####    #####    ##    ##   ##  #####    ##  ## ##
//  ##  ##   ##       ##    ##   ##  ##  ##   ##    ###
//  ##   ##  #####    ##     #####   ##   ##  ##     ##
// 表に戻る
window.addEventListener('click', function (e) {
  // 指定のクラスを持つ
  if (!e.target.classList.contains('js-allMode')) {
    return
  }
  setCookie('isR', '', cookiePath, 0, true) // Cookie発行
  setCookie('isR', '', cookiePath, 0, true, '/', 'lax', ';domain=.' + location.hostname) // Cookie発行
  if (location.hostname !== rootDomain) {
    setCookie('isR', '', cookiePath, 0, true, '/', 'lax', ';domain=.' + rootDomain) // Cookie発行
  }

  // パラメータ'page'をURLから削除
  const url = new URL(window.location.href)
  url.searchParams.delete('page')
  const cleanUrl = url.toString()

  // クッキーが切り替わるのを確認したらリロード
  const reloadTimer = setInterval(() => {
    if (getCookie('isR')) {
      return
    }

    clearInterval(reloadTimer)
    // window.location.reload()
    location.href = cleanUrl
  }, 100)
})

//      ##  ##   ##  ###    ###  #####
//      ##  ##   ##  ## #  # ##  ##  ##
//      ##  ##   ##  ##  ##  ##  #####
//  ##  ##  ##   ##  ##      ##  ##
//   ####    #####   ##      ##  ##
// 年齢認証が済んでいる場合、モーダルを飛ばしてR18ページに遷移する
window.addEventListener('click', function (e) {
  // 指定のクラスを持つ
  if (!e.target.classList.contains('js-jumpCookie')) {
    return
  }

  const rateAgree = getCookie('rateAgree')

  if (rateAgree !== '1') {
    return
  }

  const modal = document.querySelector('.js-modal--rating')
  if (modal) {
    modal.style.display = 'none'
  }
  document.getElementById('modalOverlay').style.display = 'none'
  goR18() // R18切り替え
})
